import styled from 'styled-components';

export const BlockingClicksWrapper = styled.div`
  pointer-events: none;
`;

export const Root = styled.div`
  cursor: pointer;
`;
